<template>
  <div :class="selector"
       class="side-help-tooltips">
    <transition name="group-fade">
      <HelpFloat v-if="isFixed"
                 :title="customTitle || (isPartner ? titlePartner : title)"
                 @toggle-tooltip="onToggle"
                 class="side-help-tooltips__help-float"/>
    </transition>
    <div class="side-help-tooltips__wrap">
      <button v-if="isFixed"
              type="button"
              class="side-help-tooltips__close"
              @click.prevent="onToggle">
        <span class="side-help-tooltips__close-text">{{$tGlobal('Close')}}</span>
        <span class="side-help-tooltips__close-ico">
          <BaseSvg name="ico-close"/>
        </span>
      </button>
      <HelpTooltip video-src-youtube="https://www.youtube.com/embed/BOyswIBxfRk"
                   :src="src"
                   :title="customTitle || (isPartner ? titlePartner : title)"
                   :description="customDescription || (isPartner ? descriptionPartner : description)"
                   :show-play-btn="usePlayBtn"
                   class="side-help-tooltips__inner _center-play"
      />
    </div>
  </div>
</template>

<script>
  import windowSizeMixin from '../../mixins/windowSizeMixin'
  import {blockScroll, unBlockScroll} from '../../helpers/scroll'
  import HelpFloat from '../HelpTooltipFloat'
  import HelpTooltip from '../../components/HelpTooltip'

  export default {
    mixins: [windowSizeMixin],
    components: {
      HelpFloat,
      HelpTooltip
    },
    props: {
      isPartner: {
        type: Boolean,
        default: false
      },
      usePlayBtn: {
        type: Boolean,
        default: true
      },
      isFixedCondition: {
        type: Boolean,
        default: null,
      },
      customTitle: {
        type: String,
        default: null,
      },
      customDescription: {
        type: String,
        default: null,
      },
      previewImgUrl: {
        type: String,
        default: null,
      },
    },
    data() {
      return {
        isOpen: false,

        src: this.previewImgUrl || require('@/assets/img/login/video-placeholder-auth.svg'),
        // videoSrc: {
        //   main: 'https://www.spacex.com/media/iss_docking_sim.mp4',
        //   webm: 'https://www.spacex.com/media/iss_docking_sim.webm',
        // },
        // videoSrcPartner: {
        //   main: 'https://www.spacex.com/media/iss_docking_sim.mp4',
        //   webm: 'https://www.spacex.com/media/iss_docking_sim.webm',
        // },
        title: this.$tAuth('hint_title'),
        description: `<p>${this.$tAuth('hint_text')}</p>`,
        titlePartner: this.$tAuth('hint_partner_title'),
        descriptionPartner: `<p>${this.$tAuth('hint_partner_text')}</p>`,
      }
    },
    computed: {
      isFixed() {
        return this.isFixedCondition ?? this.windowSizeMixin.width <= process.env.VUE_APP_WINDOW_SIZE_SM;
      },
      selector() {
        return {
          '_fixed': this.isFixed,
          '_open': this.isOpen
        }
      },
    },
    methods: {
      onToggle() {
        if (this.isOpen) {
          unBlockScroll()
          this.isOpen = false
        } else {
          blockScroll()
          this.isOpen = true
        }
      }
    }
  }
</script>

<style lang="less">

</style>
